<div class="demo-container">
  <button class="demo-button" 
          (click)="simulateProgressUpdates('realistic')"
          [ngClass]="{'is-active': isActive}">
    {{ isActive ? 'Demo in progress...' : 'Demo Realistic Thought Tracer' }}
  </button>
  
  <button class="demo-button demo-button-fast" 
          (click)="simulateProgressUpdates('fast')"
          [ngClass]="{'is-active': isActive}">
    Fast Demo
  </button>
  
  <div *ngIf="isActive" class="demo-info">
    Demo operation: {{demoOperationType}}
  </div>
</div>
